import Loader from 'components/loader';

import styles from './styles.module.scss';

const GlobalLoader: React.FC = () => {
  return <Loader className={styles.globalLoader} />;
};

export default GlobalLoader;
